{
  "contracts": "Contracts",
  "back": "Back",
  "start": "Start",
  "in-progress": "In progress",
  "finished": "Finished",
  "complete-btn": "Complete",
  "restart-btn": "Restart"
}